import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import image1 from "../../../assets/frontendassets/Testimonial/1.png";
import image2 from "../../../assets/frontendassets/Testimonial/2.png";
import image3 from "../../../assets/frontendassets/Testimonial/3.png";
import image4 from "../../../assets/frontendassets/Testimonial/4.png";
import image5 from "../../../assets/frontendassets/Testimonial/5.png";

import img1 from "../../../assets/frontendassets/png images/quotesRight.png";
import img2 from "../../../assets/frontendassets/png images/quotesleft.png";
import "./Review.css";
import frontendRoutes from "./../../../Routes/frontendRoutes";
import { getAllTestimonials, Testimonials } from "./../../../utils/API";
import { Autoplay } from "swiper/modules";

const App = () => {
  const [testimonialsData, setTestimonialsData] = useState<any>([]);

  const fetchReview = async () => {
    try {
      const response = await getAllTestimonials();
      setTestimonialsData(response);
      console.log("review ", response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReview();
  }, []);

  return (
    <>
      <div className="xs:pt-[22px] xs:pb-[22px] md:pt-[50px]  bg-[#FFF8EC] md:pb-[100px]">

        <div
          className="pt-[50px]"
          style={{
            backgroundColor: "#F9B138",
            height: "400px",
            borderRadius: "20px",
          }}
        >
          <h2 className="lg:text-[30px] xs:text-[20px] xxs:text-[20px] mb-6">What our Clients say!</h2>

          {testimonialsData.length > 0 ? (
            <Swiper
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              slidesPerView="auto"
              coverflowEffect={{
                rotate: 0,
                stretch: 50,
                depth: 150,
                modifier: 1,
                slideShadows: true,
              }}
              loop={true}
              pagination={{ clickable: true }}
              modules={[Autoplay]}
              autoplay={{
                delay: 3000, // Auto-slide every 3 seconds
                disableOnInteraction: false, // Keep autoplay even after user interacts
              }}
              className="mySwiper"
            >
              {testimonialsData.map((testimonial: any, index: any) => (
                <SwiperSlide
                  key={index}
                  className="testimonial-card bg-[#FFE8C2] p-4 sm:p-6 mt-[2.7rem] w-[20rem]"
                >
                  <div className="card-content text-center sm:text-left">
                    <div className="card-image mb-4 sm:mb-0">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/testimonial/${testimonial.image}`}
                        alt={testimonial.name}
                        className="w-24 h-24 sm:w-32 sm:h-32 mx-auto sm:mx-0 rounded-[20px]"
                      />
                    </div>
                    <h3 className="text-lg sm:text-xl font-semibold mt-2">
                      {testimonial.name}
                    </h3>
                    <h4 className="text-sm sm:text-sm text-gray-500 mt-1">
                      {testimonial.position}
                    </h4>
                    <div className="rounded-lg max-w-md mx-auto">
                      {/* Top Quotes */}
                      <div className="flex justify-start">
                        <img
                          src={img2}
                          alt="Left Quote"
                          className="w-6 h-6"
                        />
                      </div>

                      {/* Testimonial Text */}
                      <p className="text-gray-800 text-center text-lg font-medium">
                      <span
  className="truncate-description"
  style={{
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3, // This will limit the text to two lines
    textOverflow: 'ellipsis',
    lineHeight: '1.5rem', // Adjust line height for readability
  }}
>
  "{testimonial.description}" 
</span>

                      </p>

                      {/* Bottom Quotes */}
                      <div className="flex justify-end mt-4">
                        <img
                          src={img1}
                          alt="Right Quote"
                          className="w-6 h-6"
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper> 
          ) : (
            <div className="text-center mt-10">
              <h3 className="text-lg font-semibold text-white">
                No Review available at the moment.
              </h3>
              <p className="text-sm text-gray-100 mt-2">
                Please check back later.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default App;
